
export default function ScoreBoardDetails({compe, school1, school2, details, showModalFunc}) {

  let comp_middle;
  switch (compe) {
    case 'basket'||'futsal':
      comp_middle = 'Q';
      break;
    case 'voli':
      comp_middle = 'S'
      break;
    case 'badminton':
      comp_middle = 'M'
      break;
  }

    return (
    <div className='fixed top-0 w-full h-screen z-20 bg-black bg-opacity-60'>
        <div className="flex h-screen items-center justify-center">
          <div className="relative bg-[#fff2cd] border-[1px] border-black lg:w-3/4 w-screen">
            <span className='flex justify-center items-center text-black text-6xl mt-8 font-[britneybold]'>Details</span>
            {/* <div className='flex flex-row justify-center mt-6 gap-8'>
              <div className='h-[500px] w-[300px]'>
                <span className='flex justify-center items-center text-black text-center text-sm lg:text-2xl mt-8 font-[ClashDisplayBold]'>{school1}</span>
                {details.map((detail, index) => <span className='flex justify-center items-center h-20 text-4xl text-black font-[ClashDisplayBold]'>{detail[0]}</span>)}
              </div>
              <div className='h-[500px] w-[100px] pt-12'>
                {details.map((detail, index) => <span className='flex justify-center items-center h-20 text-4xl text-black font-[ClashDisplayBold]'>{{
                    // 'basket': "Q" + (index+1),
                    'basket': (index == 4 ? 'OT' : 'Q' + (index+1)),
                    'futsal': (index == 0 ? 'H' : 'F') + "T",
                    'voli': "S" + (index+1),
                    'badmin smp': 'M' + (index+1),
                    'badmin sma': 'M' + (index+1)
                }[compe]}</span>)}
              </div>
              <div className='h-[500px] w-[300px]'>
                <span className='flex justify-center items-center text-black text-center text-sm lg:text-2xl mt-8 font-[ClashDisplayBold]'>{school2}</span>
                {details.map((detail, index) => <span className='flex justify-center items-center h-20 text-4xl text-black font-[ClashDisplayBold]'>{detail[1]}</span>)}
              </div>
            </div> */}
            <div className={"grid grid-flow-col grid-cols-3 grid-rows-5 place-items-center text-4xl text-black text-center font-[ClashDisplayBold]"}>
              <p className="text-2xl">{school1}</p>
              {details.slice(0,4).map((v, i) => (
                details[i] ? <p>{v[0]}</p> : <p></p>
              ))}
              <p></p>
              {[1,2,3,4].map((v)=>(
                <p>{comp_middle}{v}</p>
              ))}
              <p className="text-2xl">{school2}</p>
              {details.slice(0,4).map((v, i) => (
                details[i] ? <p>{v[1]}</p> : <p></p>
              ))}

            </div>
            {console.log(details)}
            <button className='mx-auto my-8 block font-clashdisplaybold' onClick={() => showModalFunc(false)}>
            X
            </button>
          </div>
        </div>
      </div>
    );
}